import React from 'react';
import About from '../components/About/About';


const AboutUs = () => (
  <About />
);

export default AboutUs;
